import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { apiFetch } from '@/lib/api/rawFetch'
import type { MarketingEventCreate, MarketingEventResponse } from '@/lib/api/session11Types'

export function useMarketingCalendar() {
  return useQuery({
    queryKey: ['marketing'] as const,
    queryFn: () => apiFetch<MarketingEventResponse[]>('GET', '/api/marketing/'),
    staleTime: 30_000,
  })
}

export function useSaveMarketingCalendar() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (events: MarketingEventCreate[]) =>
      apiFetch<MarketingEventResponse[]>('PUT', '/api/marketing/', { body: events }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['marketing'] }),
  })
}
